import { createFileRoute } from '@tanstack/react-router'
import { PriceMatchingPage } from '@/pages/price-matching'

export const Route = createFileRoute('/_authenticated/price-matching')({
  staticData: { title: 'Price Matching' },
  component: PriceMatchingPage,
})
